"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _components = require("components");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var payPalPaymentBoxStyle = (0, _glamor.css)({
  backgroundColor: _css.colors.medLightGray,
  position: "relative",
  padding: "1.5em 0"
});

var initBox = (0, _glamor.css)({
  textAlign: "center"
});

var initInfo = (0, _glamor.css)({
  display: "block",
  lineHeight: "1.5"
});

var paypalButtonContainer = (0, _glamor.css)({
  // marginTop: '16px',
  minHeight: "44px",

  width: "200px",
  margin: " 24px auto auto",

  "& #braintree-paypal-button": {
    margin: "0 auto"
  },

  "& #braintree-paypal-loggedin": {
    borderTop: "none !important",
    borderBottom: "none !important",
    backgroundPosition: "24px 50% !important",
    backgroundSize: "20px 25px !important",
    textAlign: "left !important"
  },

  "& #bt-pp-name": {
    display: "none !important"
  },

  "& #bt-pp-email": {
    color: _css.colors.white + " !important",
    marginLeft: "55px !important",
    fontSize: (0, _css.unitRem)(0.75) + " !important",
    fontWeigt: "300 !important"
  },

  "& #bt-pp-cancel": {
    position: "absolute !important",
    right: "24px !important",
    fontSize: (0, _css.unitRem)(0.625) + " !important",
    color: _css.colors.gray + " !important",
    lineHeight: (0, _css.unitRem)(1) + " !important"
  },

  "& .paypal-button-tag-content": {
    display: "none !important"
  }
});

var errorCss = (0, _glamor.css)({
  fontSize: "0.9375rem",
  fontWeight: 400,
  display: "block",
  color: "#f44236",
  marginTop: "0.375rem"
});

var tosLink = (0, _glamor.css)({
  fontSize: "1em",
  "& a": {
    paddingLeft: "0px"
  }
});

// eslint-disable-next-line react/prefer-stateless-function
var PayPalPaymentBox = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(PayPalPaymentBox, _React$Component);

  function PayPalPaymentBox(props) {
    (0, _classCallCheck3.default)(this, PayPalPaymentBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PayPalPaymentBox.__proto__ || (0, _getPrototypeOf2.default)(PayPalPaymentBox)).call(this, props));

    _this.state = {
      message: "You are about to be redirected to PayPal to continue your purchase. By completing your purchase you agree to ",
      hideMessage: false
    };
    _this.paypalDivChanged = _this.paypalDivChanged.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(PayPalPaymentBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var containerDiv = document.getElementById(this.props.paypalContainerId);
      this.observer = new MutationObserver(this.paypalDivChanged);
      this.observer.observe(containerDiv, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.observer.disconnect();
    }
  }, {
    key: "paypalDivChanged",
    value: function paypalDivChanged(mutations) {
      for (var index = 0; index < mutations.length; index += 1) {
        var mutation = mutations[index];
        if (mutation.target.id === "braintree-paypal-loggedin") {
          if (mutation.target.style.display === "none") {
            this.setState({
              message: "Click the button below to sign in to PayPal"
            });
          } else {
            this.setState({ hideMessage: true });
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          error = _props.error,
          paypalContainerId = _props.paypalContainerId,
          paypalEmail = _props.paypalEmail;
      var _state = this.state,
          message = _state.message,
          hideMessage = _state.hideMessage;

      var text = message;

      if (paypalEmail) {
        text = "Signed in with " + paypalEmail;
      }

      return _react2.default.createElement(
        "div",
        { className: payPalPaymentBoxStyle },
        _react2.default.createElement(
          "div",
          { className: initBox },
          _react2.default.createElement(
            "span",
            { className: initInfo },
            error ? _react2.default.createElement(
              "span",
              { className: (0, _glamor.css)(errorCss) },
              error
            ) : !hideMessage && _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "p",
                { style: { display: "inline" } },
                text
              ),
              _react2.default.createElement(_components.TextButtonLibrary, {
                className: tosLink,
                mode: "small-gray-underlined",
                href: "https://www.paypal.com/us/webapps/mpp/ua/useragreement-full#top",
                label: "PayPal\u2019s user agreement.",
                newWindow: true
              })
            ),
            !paypalEmail && _react2.default.createElement("div", { className: paypalButtonContainer, id: paypalContainerId })
          )
        )
      );
    }
  }]);
  return PayPalPaymentBox;
}(_react2.default.Component), _class.propTypes = {
  paypalContainerId: _react2.default.PropTypes.string.isRequired
}, _temp);
exports.default = PayPalPaymentBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentForm/component/PayPalPaymentBox.jsx
// module id = 647
// module chunks = 0